<template>
  <div class="wrapper">
    <keep-alive>
      <component :is="comps[curTab]" class="content" :class="{'full-content': !isCN}"></component>
    </keep-alive>
    <div class="tabs" v-if="isCN">
      <span
        v-for="(item,index) in tabs"
        :key="index"
        @click="curTab=index"
        :class="{active: curTab===index}">
        {{item}}
      </span>
    </div>
  </div>
</template>

<script>
import FiveGear from './FiveGear'
import EachTick from './EachTick'
import Overview from './Overview'

export default {
  data() {
    return {
      tabs: ['五档', '明细', '大单'],
      comps: ['FiveGear', 'EachTick', 'Overview'],
      curTab: 0
    }
  },
  computed: {
    isCN () {
      return this.$store.state.region === 'CN'
    }
  },
  created() {
    if(!this.isCN) {
      this.curTab = 1
    }
  },
  components: {
    FiveGear,
    EachTick,
    Overview
  }
}
</script>

<style lang="stylus" scoped>
  .wrapper
    font-size .12rem
    margin-top .05rem
    border 1px solid #F5F5F5

  .content
    height 2.9rem

  .full-content
    height 3.15rem

  .tabs
    width 1.02rem
    height .25rem
    line-height .25rem
    color #666666
    span
      display inline-block
      width .34rem
      text-align center
  .active
    background-color #F5F5F5
    color #0A1428
</style>